<template>
  <v-main class="gb qr-container">
    <v-container fluid>
      <v-row class="header">
        <v-col cols="12" class="p-0">
          <div class="logo-container shadow module-container">
            <router-link to="/sign_up">
              <img :src="require('@/assets/logo.svg')" class="module-container"/>
            </router-link>
          </div>
        </v-col>
      </v-row>
      <v-row class="content">
        <v-col cols="12" class="p-0">
          <div class="data-container module-container">
            <!--<img class="qr-code" :src="require('@/assets/img/qr-code.svg')"/>-->
            <div class="qr-box">
              <qrcode-vue v-if="token" :value="token" :size="size" level="L"
                          class="qr-image" style="position: relative;top: 3.5px;"></qrcode-vue>
            </div>

            <p class="instruction-text mt-1">Scan to CHAT on your computer</p>
            <div class="steps-text">
              <p>
                <span>1.</span> Open the KIEY app on your cell phone.</p>
              <p style="padding-bottom: 0; margin-bottom: 0;">
                <span>2.</span> Go to the "Chats" tab, select your Profile Icon in the top right hand corner of the
                screen.</p>
              <v-img :width="250" :height="100" contain class="img-responsive"
                     :src="require('@/assets/img/qr/step_2.png')" alt=""></v-img>
              <p style="padding-bottom: 0; margin-bottom: 0;" class="mt-2"><span>3.</span> Select KIEY Web/ Desktop.</p>
              <v-img :width="250" :height="175" contain class="img-responsive"
                     :src="require('@/assets/img/qr/step_4.png')" alt=""></v-img>
              <p><span>4.</span> Click "Ok. Got it."</p>
              <p style="margin-bottom: 0; padding-bottom: 0;" class="mt-2"><span>5.</span> Point your cell phone to the
                QR
                code above to capture the code</p>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
  import {mapState, mapGetters} from "vuex";
  import QrcodeVue from 'qrcode.vue'
  import axios from 'axios'
  import config from '@/config/constants.js'
  import {firebase} from "@/config/firebase";

  export default {
    created() {
    },
    computed: {
      ...mapState({
        status: state => state.Chat.status,
        token: state => state.Chat.token,
        owner_id: state => state.Chat.owner_id,
      }),
      ...mapGetters({'getToken': ['Chat/getToken']})
    },
    data() {
      return {
        device_id: null,
        tenant_id: null,
        value: null,
        size: 150,
        level: 'L',
      };
    },
    watch: {
      owner_id(val) {
        if (!val) {
          this.initSuscription();
        } else {
          this.stopPolling();
        }
      }
    },
    mounted() {
      this._isMounted = true;
      this._polling = false;
      this._pollCancel = null;
      this.initSuscription();
    },
    beforeDestroy() {
      this._isMounted = false;
      this.stopPolling();
    },
    components: {QrcodeVue},
    methods: {
      async initSuscription() {
        const self = this;

        // Fetch web token with one retry on failure
        try {
          await this.$store.dispatch('Chat/web_token');
        } catch (err) {
          console.warn('[QR] web_token failed, retrying in 2s...', err);
          await new Promise(r => setTimeout(r, 2000));
          try {
            await this.$store.dispatch('Chat/web_token');
          } catch (err2) {
            console.error('[QR] web_token retry failed:', err2);
            return;
          }
        }

        if (!self.token) return;

        this.startPolling();
      },

      // Long-poll the backend for the device session the phone creates when it
      // scans the QR. Replaces a direct (unauthenticated) Firestore listener on
      // `devices`, which strict security rules block pre-login — the backend
      // reads `devices` with the Admin SDK, so that rule stays locked down.
      async startPolling() {
        const self = this;
        if (this._polling) return;
        this._polling = true;

        while (this._polling && this._isMounted && !self.owner_id) {
          let data;
          try {
            const source = axios.CancelToken.source();
            this._pollCancel = source;
            const response = await axios.post(
              config.api_url + 'check_web_session',
              { web_agent_id: self.token },
              { cancelToken: source.token }
            );
            data = response.data;
          } catch (err) {
            if (axios.isCancel(err)) return;
            // Transient network/server error — back off briefly and retry.
            await new Promise(r => setTimeout(r, 2000));
            continue;
          }

          if (data && data.connected && data.device && this._isMounted && !self.owner_id) {
            this._polling = false;
            this.onDeviceConnected(data.device);
            return;
          }
          // connected:false → long-poll window expired, re-poll immediately.
        }
      },

      stopPolling() {
        this._polling = false;
        if (this._pollCancel) {
          this._pollCancel.cancel();
          this._pollCancel = null;
        }
      },

      onDeviceConnected(device) {
        const self = this;
        self.$store.commit("Chat/preloading", true);
        try {
          self.$store.dispatch("Chat/generate_firebase_token", {
            user_id: device.owner_id, tenant_id: device.tenant_id, web_agent_id: self.token
          }).then(response => {

            const {device_id = "", owner_id = "", tenant_id = "", user_doc = ""} = device;

            // Establish the Firebase Auth session FIRST. Setting owner_id /
            // dispatching "logged" below starts the tenant-scoped Firestore
            // listeners, which the strict isolation rules require an
            // authenticated user for. If they run before signInWithCustomToken
            // resolves they all fail with "Missing or insufficient permissions"
            // and the chat renders blank until the user refreshes (which
            // restores auth from persistence first). So gate the session state
            // on a completed sign-in.
            firebase.auth().signInWithCustomToken(response.customToken).then(() => {
              localStorage.setItem("owner_id", owner_id);
              localStorage.setItem("auth_id", response.token);
              axios.defaults.headers.common['Authorization'] = localStorage.getItem('auth_id');
              self.$store.commit("Chat/tenant", tenant_id);
              self.$store.commit("Chat/user_doc", user_doc);
              self.$store.commit("Chat/device_id", device_id);
              self.$store.commit("Chat/owner_id", owner_id);
              self.$store.dispatch("Chat/logged");
              self.$store.dispatch("Chat/connect_device", {
                web_agent_id: self.token,
                last_device_os: navigator.platform,
                last_device_browser: navigator.userAgent,
              });
            })
              .catch((error) => {
                console.error(error);
                self.$store.dispatch("Chat/logout");
              });
          });
        } catch (errors) {
          console.error(errors)
        }
      }
    }
  };
</script>

<style lang="scss">
  .qr-box {
    background: url('../../assets/img/qr-code.svg');
    background-repeat: no-repeat;
    background-position: center;
    padding: 40px !important;
    background-color: #fafafa !important;
  }
</style>